import { render, staticRenderFns } from "./device_package.vue?vue&type=template&id=6d52790d&scoped=true&"
import script from "./device_package.vue?vue&type=script&lang=js&"
export * from "./device_package.vue?vue&type=script&lang=js&"
import style0 from "./device_package.vue?vue&type=style&index=0&id=6d52790d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52790d",
  null
  
)

export default component.exports